<section class="profile">

  <div class="profile-banner pb-3">
    <img src="../../assets/brand/profile_banner.png" class="img-fluid banner-opacity" alt="profile-banner">
    <div class="centered h1 text-gold">Dashboard</div>
  </div>

  <div class="overlap-top container my-sm-5 mt-md-0">
    <div class="row">
      <div class="col-sm-8 mb-md-5">
        <div class="row">
          <div class="col-sm-12 bg-white-opac shadow py-3 mb-5">
            <h6 class="text-uppercase mb-md-4">My Favourites</h6>
              <app-favourite-videos modalid="videoDetailsModalFav"></app-favourite-videos>
          </div>
          <div class="col-sm-12 bg-white-opac shadow mb-5">
            <div class="h6 text-uppercase py-3">My List</div>
            <div class="fs-16">
              <p class="mb-3 grey-text">Create your own list and share with your coaches.</p>
              <div class="row mb-2 custom-inputs">
                <div class="col-sm-4 col-8">
                  <!-- [ngModelOptions]="{ updateOn: 'blur' }" -->
                  <input type="text" id="dashboard-search-input" [(ngModel)]="keyword"
                    (ngModelChange)="updateOnlyOnBlur()" placeholder="Filter by Name" class="form-control">
                </div>
                <div class="col-sm-3 col-4">
                  <a class="btn btn-gold btn-filter" href="javascript:void(0);" (click)="createPlaylist()">Create
                    list</a>
                </div>

                <div class="col-12">

                  <div class="scrolldiv">
                    <div class="row py-3">
                      <div class="col-sm-3 mb-3" *ngFor="let list of items">
                        <div style="align-content: center" class="playlist-Info-box p-3 bg-white shadow">
                          <div class="h6 text-uppercase text-center py-2">{{list.list_title}} <i
                              class="fa fa-trash-can ms-2" role="button" (click)="deletePlaylist(list.id)"></i></div>
                          <p class="text-center"><strong>{{list.videos_count}} </strong><span
                              class="grey-text">Videos</span>, <strong>{{list.shared_count}} </strong><span
                              class="grey-text">Invites</span></p>
                          <div class="icons">
                            <i class="fa fa-user" title="Share List" *ngIf="user && user.role=='gymowner' && user.connections.length>0"
                              (click)="sharePlaylist(list.id)"></i>
                            <i class="fa fa-eye" title="View List" *ngIf="list.videos_count>0"
                              (click)="viewPlaylist(list.id,list.list_title)"></i>
                            <i class="fa fa-edit" title="Edit List" (click)="createPlaylist(list)"></i>
                            <i class="fa fa-video" title="Add Videos" (click)="addVideos(list.id)"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="text-center" *ngIf="currentIndex < playlists.length">
                      <button class="btn btn-sm btn-gold me-4" (click)="LoadMoreLocal()">Load More</button>
                    </div>
                  </div>
                  <!-- <div _ngcontent-ivh-c54="" class="invalid-feedback d-block"> Please fill valid email. </div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 bg-white-opac shadow py-3">
            <h6 class="text-uppercase mb-md-4">Signature Series Favourites</h6>
              <app-favourite-series-videos modalid="videoSeriesDetailsModalFav"></app-favourite-series-videos>
          </div>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="row">

          <div class="col-12 mb-5">
            <div class="card text-center border-0 shadow">
              <div class="card-header mb-5 border-0 p-0">
                <div class="icon shadow upload-image-wrap"> <img
                    *ngIf="!user || !user.profile_picture_full || user.profile_picture_full==''"
                    src="assets/brand/profile.png" class="img-fluid user-img" />
                  <img *ngIf="user && user.profile_picture_full && user.profile_picture_full!=''"
                    src="{{user.profile_picture_full}}" class="img-fluid user-img" />
                  <i class="upload-image fa fa-camera" (click)="fileUpload.click()"></i>
                </div>
                <!-- <div class="gym-title">Gym<br>Owner</div> -->
                <input type="file" class="file-upload" style="display:none" #fileUpload accept="image/*"
                  (change)="onFileSelected($event)">
              </div>
              <div class="card-body font-mulish pt-4" *ngIf="user">
                <h5 class="card-title text-uppercase font-oswald">{{user?.first_name +' '+user?.last_name}}</h5>
                <h6 class="card-subtitle mb-2 text-muted" *ngIf="user && user.role=='gymowner'">{{user.role}}<span
                    *ngIf="user.gym_name!=''">@{{user.gym_name}}</span></h6>
                <h6 class="card-subtitle mb-2 text-muted" *ngIf="user && user.role=='coach'">{{user.role}}<span
                    *ngIf="user.first_name!=''">@{{user.first_name}}</span></h6>

                <!-- <div class="row align-items-center">
                  <div class="col-4">{{user?.connections?.athlete?.length ? user?.connections?.athlete?.length : '0'}}<p class="text-muted">Connected<br/> Athlete</p>
                  </div>
                  <div class="col-4">{{user?.athlete_invites_left?.length ? user?.athlete_invites_left?.length : '0'}}<p class="text-muted">Current<br/> Limit</p>
                  </div>
                  <div class="col-4"><a href="#" class="btn btn-sm bg-gold text-white">BUY MORE</a></div>
                </div> -->
                
                <ng-container *ngIf="user && user.role=='gymowner'">
                  <div class="row align-items-center">
                    <div class="col-6">{{user?.connections?.coach?.length ?
                        user?.connections?.coach?.length : '0'}}<p class="text-muted">Connected<br /> Coaches</p>
                        
                    </div>
                    <div class="col-6">{{user?.coach_invites_left ? user?.coach_invites_left : '0'}}<p class="text-muted">
                        Current<br /> Limit</p>
                    </div>
                    <!-- <div class="col-4"><a href="#" class="btn btn-sm mt-3 btn-gold">BUY MORE</a></div> -->
                  </div>
                </ng-container>

              </div>
            </div>
          </div>

          <div *ngIf="user && user.role=='gymowner'" class="col-12">
            <div class="card border-0 shadow connections-box">
              <div class="card-body pt-4">
                <h6 class="text-uppercase">My Connections</h6>
                <app-my-connections [user]="user"></app-my-connections>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>

  <div class="modal fade" *ngIf="webApi.isLoggedIn()" id="create-playlist" tabindex="-1"
    aria-labelledby="createPlaylistLabel" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content modal-popup">
        <button _ngcontent-efl-c68="" type="button" data-bs-dismiss="modal" aria-label="Close"
          class="btn-close"></button>
        <div class="content-section">
          <form [formGroup]="playlist" (ngSubmit)="onSubmitPlaylist(playlist)">
            <div class="modal-body">

              <!-- <h5 class="mb-4">{{editPlaylist!=""?"Edit":"Create"}} a List name</h5> -->
              <h5 class="mb-4">List Name</h5>
              <div class="form-group">
                <input type="text" class="form-control" formControlName="title" placeholder="Title">
                <div class="invalid-feedback d-block"
                  *ngIf="f2['title'].errors?.['required'] && (f2['title'].dirty || f2['title'].touched)">
                  Please write list name.
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-end mt-3">
              <button type="button" class="btn btn-secondary me-3" data-bs-dismiss="modal">Close</button>
              <button type="submit" class="btn btn-gold">Create <i *ngIf="playlistSubmitting"
                  class="fa fa-spinner fa-spin"></i></button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" *ngIf="webApi.isLoggedIn()" id="add-videos" tabindex="-1" aria-labelledby="addVideos"
    aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content modal-popup">
        <button _ngcontent-efl-c68="" type="button" data-bs-dismiss="modal" aria-label="Close"
          class="btn-close"></button>
        <div class="content-section">
          <div class="modal-body">
            <h5 class="mb-4">Add videos to list</h5>
            <app-favourite-videos (updatePlaylistVideosCount)="updateCount($event)"
              [selectedPlaylist]="selectedPlaylist" type="video" modalid="videoDetailsModalFav2"></app-favourite-videos>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="modal fade" *ngIf="webApi.isLoggedIn()" id="playlist-videos" tabindex="-1"
    aria-labelledby="playlistVideos" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content modal-popup">
        <button _ngcontent-efl-c68="" type="button" data-bs-dismiss="modal" aria-label="Close"
          class="btn-close"></button>
        <div class="content-section">
          <div class="modal-body">
            <h5 class="mb-4">list Videos</h5>
            <app-playlist-videos [reinit]="reinit" [selectedPlaylist]="selectedPlaylist" type="playlist"
              modalid="videoDetailsModalPlaylisVideo2"></app-playlist-videos>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" *ngIf="user && user.role=='gymowner'" id="shareToConnections" tabindex="-1"
    aria-labelledby="shareToConnections" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content modal-popup">
        <button _ngcontent-efl-c68="" type="button" data-bs-dismiss="modal" aria-label="Close"
          class="btn-close"></button>
        <div class="content-section">
          <div class="modal-body">
            <h5 class="mb-4">Share list to Connections</h5>
            <app-my-connections [user]="user" type="share" [selectedPlaylist]="selectedPlaylist"></app-my-connections>
          </div>
        </div>
      </div>
    </div>
  </div>

</section>